"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchesTablePage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../constants/routes");
var permissions_1 = __importDefault(require("../../../../../hooks/permissions"));
var useSearchDebounce_1 = require("../../../../../hooks/useSearchDebounce");
var IUser_1 = require("../../../../../interfaces/IUser");
var branch_1 = require("../../../../../reducers/slices/branch/branch");
var branch_list_thunk_1 = require("../../../../../reducers/slices/branch/thunks/get/branch_list_thunk");
var client_user_selector_1 = require("../../../../../selectors/client_user_selector");
var branch_filter_control_1 = require("./components/branch_filter_control");
var constants_1 = require("./constants");
var branches_table_1 = require("./branches_table");
var BranchesTablePage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var searchString = (0, useSearchDebounce_1.useSearchDebounce)(1100)[0];
    var pagination = (0, react_redux_1.useSelector)(function (state) { return state.branchState; }).pagination;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var _a = (0, react_1.useState)(undefined), offline = _a[0], setOffline = _a[1];
    var _b = (0, react_1.useState)(false), showFilters = _b[0], setShowFilters = _b[1];
    var _c = (0, react_1.useState)(undefined), branchHasDelivery = _c[0], setBranchHasDelivery = _c[1];
    var branchesPermissions = (0, permissions_1.default)(IUser_1.IPermissions.BRANCHES);
    var _d = (0, react_redux_1.useSelector)(client_user_selector_1.isManagerSelector), isManager = _d.isManager, branchIdList = _d.managedBanches;
    var branch_id_list = branchIdList === null || branchIdList === void 0 ? void 0 : branchIdList.join(",");
    var query = __assign(__assign({ offline: offline, delivery: branchHasDelivery }, (searchString && { search_string: searchString })), (isManager && { branch_id_list: branch_id_list }));
    (0, react_1.useEffect)(function () {
        if ((user === null || user === void 0 ? void 0 : user._id) && (client === null || client === void 0 ? void 0 : client._id)) {
            _getBranchList({ showLoader: !searchString });
        }
    }, [user, client, searchString]);
    var _getBranchList = function (params) {
        if (params === void 0) { params = {}; }
        return dispatch((0, branch_list_thunk_1.branch_list_thunk)(__assign(__assign(__assign({}, pagination), query), params)));
    };
    var _onToggleBranch = function (offline) {
        setOffline(offline);
        _getBranchList({ offline: offline });
    };
    var _onToggleDelivery = function (delivery) {
        setBranchHasDelivery(delivery);
        _getBranchList({ delivery: delivery });
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faSlidersSimple, size: "small", backgroundColor: "bg-primary", iconColor: "text-white", onClick: function () { return setShowFilters(!showFilters); } }), showFilters && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(branch_filter_control_1.BranchFilterControl, { title: "Online", value: offline === undefined ? false : !offline, onButtonClick: function () { return _onToggleBranch(false); } }), (0, jsx_runtime_1.jsx)(branch_filter_control_1.BranchFilterControl, { title: "Offline", value: offline, onButtonClick: function (v) { return _onToggleBranch(true); } }), (0, jsx_runtime_1.jsx)(branch_filter_control_1.BranchFilterControl, { title: "Delivery", value: branchHasDelivery, onButtonClick: _onToggleDelivery })] })))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex gap-4" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: branchesPermissions.canCreate && ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Add Branch", backgroundColor: "bg-success", endIcon: pro_light_svg_icons_1.faPlus, size: "small", onClick: function () {
                                    dispatch((0, branch_1.setSelectedBranch)(constants_1.initialBranchData));
                                    navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.BRANCHES_ROUTE).concat(routes_1.BRANCH_DETAILS_ROUTE));
                                } })) })) }))] })), (0, jsx_runtime_1.jsx)(branches_table_1.BranchesTable, {})] })));
};
exports.BranchesTablePage = BranchesTablePage;
